module.exports = __webpack_public_path__ + "static/media/majorA5.12157c2.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorA5.wav
// module id = Y2Q3
// module chunks = 0